module.exports = __webpack_public_path__ + "static/media/09n.1cee9659.svg";